import { APP } from "../../../redux/constants/app.constants";

// Kept from the standalone composer page this replaced, so the injected
// reducer keeps its identity.
export const APP_PAGE_COMPOSER = `${APP}/APP_PAGE_COMPOSER`;

export const SET_EDIT_APP_PAGE = `${APP_PAGE_COMPOSER}/SET_EDIT_APP_PAGE`;
export const SET_EXAMPLE_TILE = `${APP_PAGE_COMPOSER}/SET_EXAMPLE_TILE`;
